module.exports = __webpack_public_path__ + "static/media/icon_detalhes_agenda.2d4c279e.svg";